module.exports = __webpack_public_path__ + "static/img/s-oppo-1.f5ecff6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-oppo-1.png
// module id = tp9k
// module chunks = 1